import { render, staticRenderFns } from "./composantLabelEditable.vue?vue&type=template&id=0ef8add6&scoped=true"
import script from "./composantLabelEditable.vue?vue&type=script&lang=js"
export * from "./composantLabelEditable.vue?vue&type=script&lang=js"
import style0 from "./composantLabelEditable.vue?vue&type=style&index=0&id=0ef8add6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8add6",
  null
  
)

export default component.exports